import React from "react";

export const WhatsAppIcon = () => (
  <svg
    className={"btn-icon"}
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={"M12.04 2a9.9 9.9 0 0 0-8.5 14.98L2 22l5.16-1.5A9.93 9.93 0 1 0 12.04 2Zm0 18.13c-1.5 0-2.97-.4-4.25-1.17l-.3-.18-3.07.9.9-2.98-.2-.31a8.2 8.2 0 1 1 6.92 3.74Zm4.5-6.14c-.25-.12-1.46-.72-1.69-.8-.23-.08-.39-.12-.55.12-.16.25-.63.8-.78.97-.14.16-.29.18-.53.06-.25-.12-1.04-.38-1.98-1.22a7.43 7.43 0 0 1-1.37-1.7c-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.15.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.13-.55-1.33-.76-1.82-.2-.48-.4-.41-.55-.42h-.47a.9.9 0 0 0-.66.31c-.23.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.54.12.17 1.73 2.64 4.2 3.7.58.25 1.04.4 1.4.52.59.19 1.12.16 1.54.1.47-.07 1.46-.6 1.66-1.18.21-.58.21-1.08.15-1.18-.06-.1-.23-.17-.47-.29Z"} />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={"M12 1a11 11 0 0 0-1.72 21.87v-7.69H7.49V12h2.79V9.58c0-2.76 1.64-4.28 4.15-4.28 1.2 0 2.46.21 2.46.21v2.71h-1.39c-1.37 0-1.8.85-1.8 1.72V12h3.06l-.49 3.18h-2.57v7.69A11 11 0 0 0 12 1Z"} />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={"M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22Zm-3.1 5.2h6.2a2.7 2.7 0 0 1 2.7 2.7v6.2a2.7 2.7 0 0 1-2.7 2.7H8.9a2.7 2.7 0 0 1-2.7-2.7V8.9a2.7 2.7 0 0 1 2.7-2.7Zm0 1.3c-.77 0-1.4.63-1.4 1.4v6.2c0 .77.63 1.4 1.4 1.4h6.2c.77 0 1.4-.63 1.4-1.4V8.9c0-.77-.63-1.4-1.4-1.4H8.9Zm6.75.85a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 1.3a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Z"} />
  </svg>
);

//Thin chevron used on the slideshows
export const Chevron = ({ isNext }) => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={isNext ? "M9 4l8 8-8 8" : "M15 4l-8 8 8 8"} />
  </svg>
);
